import { FC } from 'react';
import { DataRoomActivityActorType } from 'shared';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { StringKey } from '../../../../lang/index';

/**
 * Which of 20.1.0 §1's two countable identities a visitor is, in the words the Access screens use.
 *
 * Internal and External rather than the journal's own spelling, so one person does not read as a
 * "Stakeholder" on this tab and as "Internal" two clicks away.
 */
export const VISITOR_TYPE_LABEL: Record<DataRoomActivityActorType, StringKey> = {
  [DataRoomActivityActorType.EXTERNAL_GUEST]: 'EXTERNAL',
  [DataRoomActivityActorType.STAKEHOLDER]: 'INTERNAL',
};

/**
 * The Type column.
 *
 * A dash only where neither the journal nor a grant can say, which is a grant deleted with its
 * room and no activity left to read a type off.
 */
export const VisitorTypeLabel: FC<{ actorType: DataRoomActivityActorType | null }> = ({
  actorType,
}) =>
  actorType ? (
    <AppFormattedMessage id={VISITOR_TYPE_LABEL[actorType]} />
  ) : (
    <span className="text-gray-400">–</span>
  );
